import { SimpleGrid, Text } from "@chakra-ui/react";
import { useContext, useMemo } from "react";
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import EggCard from "./eggCard";
import { useTranslation } from "next-i18next";

type Props = {
    shadow?: boolean;
};
export default function MyEggs({shadow}:Props) {

    const { t } = useTranslation();
    const {
        myItems,
        isMyItemsLoading,
        config
    } = useContext(GlobalDataUserContext)

    const sortedEggs = useMemo(() => {
        return myItems
    }, [myItems]);

    if ( shadow) {
        return (<>{ sortedEggs && <SimpleGrid columns={{base:2,md:3,lg:4}} spacing={5} w="full" p={5}>
            {sortedEggs?.slice(0, 8).map((egg) => {
                return <EggCard key={egg.id} id={egg.id} type={egg.type} />
            }) }     
        </SimpleGrid> }</>)
    }
    return (
        <>
            <SimpleGrid zIndex={2} columns={{base:2,md:3,lg:4}} spacing={5} w="full" p={5} pt={0}>
                {sortedEggs && <>
                    {sortedEggs?.map((egg) => {
                        return  <EggCard key={egg.id} id={egg.id} type={egg.type} /> 
                    })}
                </>
                }
            </SimpleGrid> 
            {!isMyItemsLoading && (!sortedEggs || sortedEggs.length == 0 )&& <Text px={2} color="white">
                {t("eggs.noEggs")}
                </Text>}
        </>
    )
}